module.exports = __webpack_public_path__ + "static/img/holiday-results-2.3d80158.png";